import { Component, OnInit } from '@angular/core';
import { BindModalResult } from 'src/app/model';
import { DmStoreService } from 'src/app/store/dm-store.service';
import { HelperProvider } from 'src/app/providers/helper/helper';
import { ApiService } from 'src/app/providers/api/api.service';
import { IonicModule, ModalController } from '@ionic/angular';
import { Validators, FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GroupBindStoreService } from 'src/app/store/group-bind-store.service';
import { LocaLstorageService } from 'src/app/store/localstorage.service';
import { EValid } from 'src/app/app.utils';
import { CommonModule } from '@angular/common';
import { ZoneSelectComponent } from '../zone-select/zone-select.component';
import { LevelSelectComponent } from '../level-select/level-select.component';
import { GroupSelectComponent } from '../group-select/group-select.component';
import { LabelsSelectComponent } from '../labels-select/labels-select.component';
import { ProjectSelectComponent } from '../project-select/project-select.component';
import { OwnerSelectComponent } from '../owner-select/owner-select.component';
import { UserProfile } from 'src/app/providers';

@Component({
  selector: 'app-group-bind',
  templateUrl: './group-bind.component.html',
  styleUrls: ['./group-bind.component.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule, CommonModule, ReactiveFormsModule, ZoneSelectComponent, LevelSelectComponent, GroupSelectComponent, LabelsSelectComponent, ProjectSelectComponent, OwnerSelectComponent],
})
export class GroupBindComponent implements OnInit {
  public isAdmin = false;
  public showIntervalPlacing: boolean;
  public groupSettings: FormGroup = new FormGroup({
    selectedIntervalMControl: new FormControl(this.optionsStore.intervalMeters, Validators.compose([
      Validators.required,
      Validators.min(0.5),
      Validators.max(100),
      Validators.pattern('^[0-9.]+$'),
    ])),
    sensorsControl: new FormControl(this.groupBindStore.devicesNumber || '', Validators.compose([
      Validators.required,
      Validators.min(2),
      Validators.max(100),
      Validators.pattern('^[0-9]+$'),
    ])),
  });

  constructor(
    private dmStore: DmStoreService,
    private helper: HelperProvider,
    private modalController: ModalController,
    private optionsStore: LocaLstorageService,
    private api: ApiService,
    private groupBindStore: GroupBindStoreService,
    private userProfile: UserProfile,
  ) {}

  async ngOnInit() {
    this.isAdmin = await this.userProfile.isAdmin();
    this.showIntervalPlacing = this.optionsStore.intervalPlacing;
    this.groupSettings = new FormGroup({
      selectedIntervalMControl: new FormControl(this.optionsStore.intervalMeters, Validators.compose([
        Validators.required,
        Validators.min(0.5),
        Validators.max(100),
        Validators.pattern('^[0-9.]+$'),
      ])),
      sensorsControl: new FormControl(this.groupBindStore.devicesNumber || '', Validators.compose([
        Validators.required,
        Validators.min(2),
        Validators.max(100),
        Validators.pattern('^[0-9]+$'),
      ])),
    });

    this.groupSettings.controls['sensorsControl'].reset();
  }

  public selectNumberOfSensors() {
    this.groupBindStore.devicesNumber = this.groupSettings.value.sensorsControl;
  }

  async bind() {
    if (this.disableSubmit()) {
      return;
    }
    this.groupBindStore.openGroupBindTab = true;
    this.groupBindStore.group = this.dmStore.selectedGroup.getValue();
    this.groupBindStore.zone = this.dmStore.selectedZone.getValue();
    this.optionsStore.intervalMeters = this.groupSettings.value.selectedIntervalMControl;

    if (!this.groupBindStore.group || !this.groupBindStore.zone) {
      return;
    }

    this.helper.showLoading();
    const { positions } = await this.api.positions.getPositions({ group_id: [this.groupBindStore.group.id] }, this.helper);
    this.helper.hideLoading();

    this.groupBindStore.existingPositions = positions || [];

    const result: BindModalResult = { accurate: true };

    if (await this.modalController.getTop()) {
      this.modalController.dismiss(result);
    }
  }

  public disableSubmit = () => !this.dmStore.selectedGroup.getValue() || this.groupSettings.status !== EValid.valid;

}
